import React from 'react';

import { Button, Tooltip } from 'antd';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const FilterClearButton = ({ onClick }) => {
    return (
        <Tooltip title="Clear filter">
            <Button
                size="small"
                shape="circle"
                onClick={onClick}
                icon={<NwIcon icon={byPrefixAndName.fasl['xmark']} />}
            />
        </Tooltip>
    );
};

export default FilterClearButton;
